<div class="container" *ngIf="!isLoading">
    <div class="back-button" (click)="backButtonClick()">
        {{ 'device-list.back' | translate }}
    </div>

    <ng-container *ngIf="!showInfoMessage">
        <div class="title-container">
            <div class="title">{{ 'device-list.title' | translate }}</div>
            <div class="subtitle">{{ 'device-list.subtitle' | translate }}</div>
        </div>

        <div class="buttons-container">
            <div class="button" (click)="cancel()">
                {{ 'dlg.cancel' | translate }}
            </div>
            <div class="save-button" [class.saveDisabled]="isSaveDisabled()" (click)="save()">
                {{ 'dlg.save' | translate }}
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="showInfoMessage">
        <div class="title-container">
            <div class="title">{{ 'device-list.title' | translate }}</div>
        </div>

        <div class="message-container">
            <mat-icon svgIcon="device-list" />
            <div class="message-title">
                {{ 'device-list.start-editing.title' | translate }}
            </div>
            <div class="text-message">
                <div>{{ 'device-list.start-editing.text-1' | translate }}</div>
                <br />
                <div>{{ 'device-list.start-editing.text-2' | translate }}</div>
                <br />
                <div>{{ 'device-list.start-editing.text-3' | translate }}</div>
            </div>

            <div class="start-editing">
                <div class="start-editing-button" (click)="showInfoMessage = false">
                    {{ 'device-list.start-editing.start-button' | translate }}
                </div>
            </div>
        </div>
    </ng-container>

    <div class="device-list-main" [class.disabled]="showInfoMessage">
        <ng-container *ngFor="let device of deviceList">
            <app-dropdown-accordion
                [header]="device?.name"
                [hasBulkEdit]="hasBulkEdit(device)"
                [isEditing]="isBulkEditing(device)"
                (onBulkEditChange)="handleBulkEditChange($event, device)">
                <ng-container *ngIf="device?.name == FCU_DEVICE">
                    <app-single-device-list
                        [models]="device.models"
                        [vesselEquipment]="vesselEquipment"
                        [initialVesselEquipment]="initialVesselEquipment"
                        [vesselId]="vessel.iAPIVesselId"
                        [deviceType]="FCU_DEVICE"
                        (onVesselEquipmentChanged)="handleEquipmentChange($event)"></app-single-device-list>
                </ng-container>
                <ng-container *ngIf="device?.name == FU_DEVICE && fuUnits?.length > 0">
                    <app-nested-device-list
                        [models]="device.models"
                        [vesselEquipment]="vesselEquipment"
                        [initialVesselEquipment]="initialVesselEquipment"
                        [vesselId]="vessel.iAPIVesselId"
                        [units]="fuUnits"
                        [deviceType]="FU_DEVICE"
                        (onVesselEquipmentChanged)="handleEquipmentChange($event)"></app-nested-device-list>
                </ng-container>
                <ng-container *ngIf="device?.name == OPS_DEVICE">
                    <app-multiple-device-list
                        #opsUnitList
                        [models]="device.models"
                        [units]="opsUnits"
                        [vesselEquipment]="vesselEquipment"
                        [initialVesselEquipment]="initialVesselEquipment"
                        [vesselId]="vessel.iAPIVesselId"
                        [deviceType]="OPS_DEVICE"
                        (onVesselEquipmentChanged)="handleEquipmentChange($event)"
                        (onCloseBulkEdit)="closeBulkEdit(OPS_DEVICE)"></app-multiple-device-list>
                </ng-container>
                <ng-container *ngIf="device?.name == IEDGE_DEVICE">
                    <app-single-device-list
                        [models]="device.models"
                        [vesselEquipment]="vesselEquipment"
                        [initialVesselEquipment]="initialVesselEquipment"
                        [vesselId]="vessel.iAPIVesselId"
                        [deviceType]="IEDGE_DEVICE"
                        (onVesselEquipmentChanged)="handleEquipmentChange($event)"></app-single-device-list>
                </ng-container>
                <ng-container *ngIf="device?.name == IO_DEVICE && getIOUnitsList()?.length > 0">
                    <app-multiple-device-list
                        [models]="device.models"
                        [units]="getIOUnitsList()"
                        [vesselEquipment]="vesselEquipment"
                        [initialVesselEquipment]="initialVesselEquipment"
                        [vesselId]="vessel.iAPIVesselId"
                        [deviceType]="IO_DEVICE"
                        (onVesselEquipmentChanged)="handleEquipmentChange($event)"></app-multiple-device-list>
                </ng-container>
                <ng-container *ngIf="device?.name == CEU_DEVICE && ceuUnits?.length > 0">
                    <app-nested-device-list
                        [models]="device.models"
                        [vesselEquipment]="vesselEquipment"
                        [initialVesselEquipment]="initialVesselEquipment"
                        [vesselId]="vessel.iAPIVesselId"
                        [units]="ceuUnits"
                        [deviceType]="CEU_DEVICE"
                        (onVesselEquipmentChanged)="handleEquipmentChange($event)"></app-nested-device-list>
                </ng-container>
                <ng-container *ngIf="device?.name == EAP_DEVICE">
                    <app-single-device-list
                        [models]="device.models"
                        [vesselEquipment]="vesselEquipment"
                        [initialVesselEquipment]="initialVesselEquipment"
                        [vesselId]="vessel.iAPIVesselId"
                        [deviceType]="EAP_DEVICE"
                        (onVesselEquipmentChanged)="handleEquipmentChange($event)"></app-single-device-list>
                </ng-container>
                <ng-container *ngIf="device?.name == PRINTER_DEVICE && printers?.length > 0">
                    <app-multiple-device-list
                        #printerUnitList
                        [models]="device.models"
                        [units]="printers"
                        [vesselEquipment]="vesselEquipment"
                        [initialVesselEquipment]="initialVesselEquipment"
                        [vesselId]="vessel.iAPIVesselId"
                        [deviceType]="PRINTER_DEVICE"
                        (onVesselEquipmentChanged)="handleEquipmentChange($event)"
                        (onCloseBulkEdit)="closeBulkEdit(PRINTER_DEVICE)"></app-multiple-device-list>
                </ng-container>
                <ng-container *ngIf="device?.name == KEYBOARD_DEVICE">
                    <app-single-device-list
                        [models]="device.models"
                        [vesselEquipment]="vesselEquipment"
                        [initialVesselEquipment]="initialVesselEquipment"
                        [vesselId]="vessel.iAPIVesselId"
                        [deviceType]="KEYBOARD_DEVICE"
                        (onVesselEquipmentChanged)="handleEquipmentChange($event)"></app-single-device-list>
                </ng-container>
                <ng-container *ngIf="device?.name == TRACKBALL_DEVICE">
                    <app-single-device-list
                        [models]="device.models"
                        [vesselEquipment]="vesselEquipment"
                        [initialVesselEquipment]="initialVesselEquipment"
                        [vesselId]="vessel.iAPIVesselId"
                        [deviceType]="TRACKBALL_DEVICE"
                        (onVesselEquipmentChanged)="handleEquipmentChange($event)"></app-single-device-list>
                </ng-container>
                <ng-container *ngIf="device?.name == HUB_DEVICE">
                    <app-single-device-list
                        [models]="device.models"
                        [vesselEquipment]="vesselEquipment"
                        [initialVesselEquipment]="initialVesselEquipment"
                        [vesselId]="vessel.iAPIVesselId"
                        [deviceType]="HUB_DEVICE"
                        (onVesselEquipmentChanged)="handleEquipmentChange($event)"></app-single-device-list>
                </ng-container>
                <ng-container *ngIf="isCustomDevice(device?.name) && getCustomDeviceUnits(device?.name)?.length > 0">
                    <app-multiple-device-list
                        [models]="device.models"
                        [units]="getCustomDeviceUnits(device?.name)"
                        [vesselEquipment]="vesselEquipment"
                        [initialVesselEquipment]="initialVesselEquipment"
                        [vesselId]="vessel.iAPIVesselId"
                        [deviceType]="device?.name"
                        (onVesselEquipmentChanged)="handleEquipmentChange($event)"></app-multiple-device-list>
                </ng-container>
            </app-dropdown-accordion>
        </ng-container>
    </div>
</div>

<ng-container *ngIf="isLoading"> <app-loading-spinner class="spinner-loading"></app-loading-spinner></ng-container>
